import React from 'react';
import '../../styles/modal.css';
import { useLanguage } from "../common/LanguageContext";

function ContactModal({ onClose }) {
  const { translations } = useLanguage();

  return (
    <div className="modal">
      <button className="modal-close" onClick={onClose}>
        &times;
      </button>
      <h2>{translations.contacUs.title}</h2>
      <form>
        <label>
          {translations.contacUs.mail}
          <input type="email" required />
        </label>
        <label>
          {translations.contacUs.phone}
          <input type="tel" required />
        </label>
        <label>
          {translations.contacUs.msg}
          <textarea />
        </label>
        <button type="submit">{translations.contacUs.btnText}</button>
      </form>
    </div>
  );
}

export default ContactModal;
